import ajax from '../../common/services/httpService';

/**
 * @param {{
 *   siteId: number;
 *   time: { timeFrom: string; timeTo: string };
 *   shiftIds?: number[];
 *   defaultVisitsPerClean: number;
 *   avgMinutesPerClean?: number;
 * }} body
 */
export function computeCleaningWorkPlan(body) {
	return ajax.post('work-plan/compute', body);
}

/**
 * @param {{
 *   siteId: number;
 *   time: { timeFrom: string; timeTo: string };
 *   shiftIds?: number[];
 * }} body
 */
export function fetchCleanerConnectionStats(body) {
	return ajax.post('work-plan/cleaner-connection-stats', body);
}

/**
 * @param {{
 *   rooms: Array<{
 *     roomName: string;
 *     building: string;
 *     floor: string;
 *     zone?: string;
 *     gender: string;
 *     demandVisits: number;
 *     arrivals: number;
 *   }>;
 *   desiredEmployees: number;
 *   visitsPerClean: number;
 *   avgMinutesPerClean?: number;
 *   totalCleaningMinutes?: number;
 *   totalCleaningHours?: number;
 * }} body
 */
export function requestAiAllocation(body) {
	return ajax.post('work-plan/ai-allocate', body);
}
